import Select from '@/components/ui/select/select';
export default Select;
